<template>
  <!-- <a v-if="toPath && toPath[0] !== '/'" :href="toPath" target="_blank">
    <slot></slot>
  </a>
  <router-link v-else :to="toPath">
    <slot></slot>
  </router-link> -->
  <router-link v-if="isDomain == true" :to="url">
    <slot></slot>
  </router-link>
  <a v-else :href="url" target="_blank">
    <slot></slot>
  </a>
</template>
<script>
  export default {
    name: 'aLink',
    data(){
      return{
        isDomain:true,
        url:'',
      }
    },
    props: ['toPath'],
    computed: {
    //   vProps() {
    //     return {...this.$props, ...this.$attrs}
    //   }
    },
    watch: {
      toPath: function(newVal,oldVal){
        this.url = newVal;  //newVal即是chartData
        this.isLink();
      },
    },
    methods: {
      isLink(){
        var _this = this , _isDomain = null , urlStr = '';
        urlStr = _this.toPath;
        if(urlStr){
          _isDomain = urlStr.indexOf('radio.cgtn.com');
          if(_isDomain != -1){
            urlStr = urlStr.split('https://radio.cgtn.com');
            _this.url = urlStr[1];
            _this.isDomain = true;
          }else if(urlStr[0] === '/'){
            _this.url = urlStr;
            _this.isDomain = true;
          }else{
            _this.url = urlStr;
            _this.isDomain = false;
          }
        }
      },
    },
    created () {
      
    },
    mounted(){
      this.isLink();
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/aLink/index.vue